"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PronunciationApi = exports.PronunciationApiFactory = exports.PronunciationApiFp = exports.PronunciationApiAxiosParamCreator = exports.MetadataApi = exports.MetadataApiFactory = exports.MetadataApiFp = exports.MetadataApiAxiosParamCreator = exports.ConfusionApi = exports.ConfusionApiFactory = exports.ConfusionApiFp = exports.ConfusionApiAxiosParamCreator = exports.ProsodyTargetDtoV2IntonationEnum = exports.ProsodyTargetDtoV2PauseEnum = exports.ProsodyTargetDtoV1IntonationEnum = exports.ProsodyTargetDtoV1PauseEnum = exports.PronunciationRequestDtoV2TargetLanguageEnum = exports.PronunciationRequestDtoV1TargetLanguageEnum = exports.PronunciationMetadataRequestDtoV1LanguageEnum = exports.PronunciationDtoV2PhonemesDurationEnum = exports.PhrasePronunciationDtoV2LanguageEnum = exports.PhrasePronunciationDtoV1LanguageEnum = exports.MetadataRequestDtoV1TargetLanguageEnum = exports.ConfusionRuleDtoV1LanguageEnum = void 0;
const axios_1 = require("axios");
const common_1 = require("./common");
const base_1 = require("./base");
exports.ConfusionRuleDtoV1LanguageEnum = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
exports.MetadataRequestDtoV1TargetLanguageEnum = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
exports.PhrasePronunciationDtoV1LanguageEnum = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
exports.PhrasePronunciationDtoV2LanguageEnum = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
exports.PronunciationDtoV2PhonemesDurationEnum = {
    short: 'short',
    normal: 'normal',
    long: 'long',
    superlong: 'superlong'
};
exports.PronunciationMetadataRequestDtoV1LanguageEnum = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
exports.PronunciationRequestDtoV1TargetLanguageEnum = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
exports.PronunciationRequestDtoV2TargetLanguageEnum = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
exports.ProsodyTargetDtoV1PauseEnum = {
    prohibited: 'prohibited',
    optional: 'optional',
    mandatory: 'mandatory'
};
exports.ProsodyTargetDtoV1IntonationEnum = {
    falling: 'falling',
    rising: 'rising',
    flat: 'flat'
};
exports.ProsodyTargetDtoV2PauseEnum = {
    prohibited: 'prohibited',
    optional: 'optional',
    mandatory: 'mandatory'
};
exports.ProsodyTargetDtoV2IntonationEnum = {
    falling: 'falling',
    rising: 'rising',
    flat: 'flat'
};
const ConfusionApiAxiosParamCreator = function (configuration) {
    return {
        addConfusionsV1: async (lang, addConfusionDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('addConfusionsV1', 'lang', lang);
            (0, common_1.assertParamExists)('addConfusionsV1', 'addConfusionDtoV1', addConfusionDtoV1);
            const localVarPath = `/v1/confusions/{lang}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addConfusionDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteConfusionsV1: async (lang, key, options = {}) => {
            (0, common_1.assertParamExists)('deleteConfusionsV1', 'lang', lang);
            (0, common_1.assertParamExists)('deleteConfusionsV1', 'key', key);
            const localVarPath = `/v1/confusions/{lang}/{key}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getConfusionsV1: async (lang, options = {}) => {
            (0, common_1.assertParamExists)('getConfusionsV1', 'lang', lang);
            const localVarPath = `/v1/confusions/{lang}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateConfusionsV1: async (lang, key, updateConfusionDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('updateConfusionsV1', 'lang', lang);
            (0, common_1.assertParamExists)('updateConfusionsV1', 'key', key);
            (0, common_1.assertParamExists)('updateConfusionsV1', 'updateConfusionDtoV1', updateConfusionDtoV1);
            const localVarPath = `/v1/confusions/{lang}/{key}`
                .replace(`{${"lang"}}`, encodeURIComponent(String(lang)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateConfusionDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ConfusionApiAxiosParamCreator = ConfusionApiAxiosParamCreator;
const ConfusionApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ConfusionApiAxiosParamCreator)(configuration);
    return {
        async addConfusionsV1(lang, addConfusionDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConfusionsV1(lang, addConfusionDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteConfusionsV1(lang, key, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConfusionsV1(lang, key, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getConfusionsV1(lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfusionsV1(lang, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateConfusionsV1(lang, key, updateConfusionDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfusionsV1(lang, key, updateConfusionDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ConfusionApiFp = ConfusionApiFp;
const ConfusionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ConfusionApiFp)(configuration);
    return {
        addConfusionsV1(lang, addConfusionDtoV1, options) {
            return localVarFp.addConfusionsV1(lang, addConfusionDtoV1, options).then((request) => request(axios, basePath));
        },
        deleteConfusionsV1(lang, key, options) {
            return localVarFp.deleteConfusionsV1(lang, key, options).then((request) => request(axios, basePath));
        },
        getConfusionsV1(lang, options) {
            return localVarFp.getConfusionsV1(lang, options).then((request) => request(axios, basePath));
        },
        updateConfusionsV1(lang, key, updateConfusionDtoV1, options) {
            return localVarFp.updateConfusionsV1(lang, key, updateConfusionDtoV1, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ConfusionApiFactory = ConfusionApiFactory;
class ConfusionApi extends base_1.BaseAPI {
    addConfusionsV1(lang, addConfusionDtoV1, options) {
        return (0, exports.ConfusionApiFp)(this.configuration).addConfusionsV1(lang, addConfusionDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    deleteConfusionsV1(lang, key, options) {
        return (0, exports.ConfusionApiFp)(this.configuration).deleteConfusionsV1(lang, key, options).then((request) => request(this.axios, this.basePath));
    }
    getConfusionsV1(lang, options) {
        return (0, exports.ConfusionApiFp)(this.configuration).getConfusionsV1(lang, options).then((request) => request(this.axios, this.basePath));
    }
    updateConfusionsV1(lang, key, updateConfusionDtoV1, options) {
        return (0, exports.ConfusionApiFp)(this.configuration).updateConfusionsV1(lang, key, updateConfusionDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ConfusionApi = ConfusionApi;
const MetadataApiAxiosParamCreator = function (configuration) {
    return {
        getMetadataV1: async (metadataRequestDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('getMetadataV1', 'metadataRequestDtoV1', metadataRequestDtoV1);
            const localVarPath = `/v1/metadata`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(metadataRequestDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPronunciationMetadataV1: async (pronunciationMetadataRequestDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('getPronunciationMetadataV1', 'pronunciationMetadataRequestDtoV1', pronunciationMetadataRequestDtoV1);
            const localVarPath = `/v1/metadata/pronunciation`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pronunciationMetadataRequestDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MetadataApiAxiosParamCreator = MetadataApiAxiosParamCreator;
const MetadataApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MetadataApiAxiosParamCreator)(configuration);
    return {
        async getMetadataV1(metadataRequestDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetadataV1(metadataRequestDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPronunciationMetadataV1(pronunciationMetadataRequestDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPronunciationMetadataV1(pronunciationMetadataRequestDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.MetadataApiFp = MetadataApiFp;
const MetadataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MetadataApiFp)(configuration);
    return {
        getMetadataV1(metadataRequestDtoV1, options) {
            return localVarFp.getMetadataV1(metadataRequestDtoV1, options).then((request) => request(axios, basePath));
        },
        getPronunciationMetadataV1(pronunciationMetadataRequestDtoV1, options) {
            return localVarFp.getPronunciationMetadataV1(pronunciationMetadataRequestDtoV1, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MetadataApiFactory = MetadataApiFactory;
class MetadataApi extends base_1.BaseAPI {
    getMetadataV1(metadataRequestDtoV1, options) {
        return (0, exports.MetadataApiFp)(this.configuration).getMetadataV1(metadataRequestDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    getPronunciationMetadataV1(pronunciationMetadataRequestDtoV1, options) {
        return (0, exports.MetadataApiFp)(this.configuration).getPronunciationMetadataV1(pronunciationMetadataRequestDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MetadataApi = MetadataApi;
const PronunciationApiAxiosParamCreator = function (configuration) {
    return {
        getPronunciationsV1: async (pronunciationRequestDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('getPronunciationsV1', 'pronunciationRequestDtoV1', pronunciationRequestDtoV1);
            const localVarPath = `/v1/pronunciations/g2p`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pronunciationRequestDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPronunciationsV2: async (pronunciationRequestDtoV2, options = {}) => {
            (0, common_1.assertParamExists)('getPronunciationsV2', 'pronunciationRequestDtoV2', pronunciationRequestDtoV2);
            const localVarPath = `/v2/pronunciations/g2p`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pronunciationRequestDtoV2, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PronunciationApiAxiosParamCreator = PronunciationApiAxiosParamCreator;
const PronunciationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PronunciationApiAxiosParamCreator)(configuration);
    return {
        async getPronunciationsV1(pronunciationRequestDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPronunciationsV1(pronunciationRequestDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPronunciationsV2(pronunciationRequestDtoV2, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPronunciationsV2(pronunciationRequestDtoV2, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.PronunciationApiFp = PronunciationApiFp;
const PronunciationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PronunciationApiFp)(configuration);
    return {
        getPronunciationsV1(pronunciationRequestDtoV1, options) {
            return localVarFp.getPronunciationsV1(pronunciationRequestDtoV1, options).then((request) => request(axios, basePath));
        },
        getPronunciationsV2(pronunciationRequestDtoV2, options) {
            return localVarFp.getPronunciationsV2(pronunciationRequestDtoV2, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PronunciationApiFactory = PronunciationApiFactory;
class PronunciationApi extends base_1.BaseAPI {
    getPronunciationsV1(pronunciationRequestDtoV1, options) {
        return (0, exports.PronunciationApiFp)(this.configuration).getPronunciationsV1(pronunciationRequestDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    getPronunciationsV2(pronunciationRequestDtoV2, options) {
        return (0, exports.PronunciationApiFp)(this.configuration).getPronunciationsV2(pronunciationRequestDtoV2, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PronunciationApi = PronunciationApi;
//# sourceMappingURL=api.js.map